var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-response',{attrs:{"model":_vm.value,"data":_vm.source,"loading":false},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }